var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isOpen
      ? _c("div", { staticClass: "backdrop", on: { click: _vm.closeDrawer } })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { class: ["drawer", { "drawer--open": _vm.isOpen }] }, [
      _c("div", { staticClass: "drawer-header" }, [
        _c("button", { on: { click: _vm.closeDrawer } }, [_vm._v("X")]),
        _vm._v(" "),
        _c("div", { staticClass: "header-title" }, [
          _c("h2", [_vm._v("Profile Completion")]),
          _vm._v(" "),
          _c("div", { staticClass: "percent" }, [
            _vm._v(_vm._s(_vm.data.profilePercentComplete + "%"))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "progress-bar" }, [
          _c("div", {
            staticClass: "progress",
            style: { width: _vm.data.profilePercentComplete + "%" }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "drawer-content" }, [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c("ul", [
              _c("li", [
                _c("span", { staticClass: "item-title" }, [
                  _vm.data.personalDetails.completed
                    ? _c("span", { staticClass: "checkmark" }, [
                        _c("i", { staticClass: "fa fa-check" })
                      ])
                    : _c("span", { staticClass: "plusmark" }, [
                        _c("i", { staticClass: "fa fa-plus" })
                      ]),
                  _vm._v(
                    "\n                            Personal Details\n                        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "action-button",
                    class: {
                      edit: _vm.data.personalDetails.edit,
                      add: !_vm.data.personalDetails.edit
                    },
                    attrs: { href: _vm.data.personalDetails.link }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.data.personalDetails.edit ? "EDIT" : "ADD") +
                        "\n                        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", { staticClass: "item-title" }, [
                  _vm.data.introduceYourSelf.completed
                    ? _c("span", { staticClass: "checkmark" }, [
                        _c("i", { staticClass: "fa fa-check" })
                      ])
                    : _c("span", { staticClass: "plusmark" }, [
                        _c("i", { staticClass: "fa fa-plus" })
                      ]),
                  _vm._v(
                    "\n                            Introduce Your Self\n                        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "action-button",
                    class: {
                      edit: _vm.data.introduceYourSelf.edit,
                      add: !_vm.data.introduceYourSelf.edit
                    },
                    attrs: { href: _vm.data.introduceYourSelf.link }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.data.introduceYourSelf.edit ? "EDIT" : "ADD"
                        ) +
                        "\n                        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", { staticClass: "item-title" }, [
                  _vm.data.yourBio.completed
                    ? _c("span", { staticClass: "checkmark" }, [
                        _c("i", { staticClass: "fa fa-check" })
                      ])
                    : _c("span", { staticClass: "plusmark" }, [
                        _c("i", { staticClass: "fa fa-plus" })
                      ]),
                  _vm._v(
                    "\n                            Your Bio\n                        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "action-button",
                    class: {
                      edit: _vm.data.yourBio.edit,
                      add: !_vm.data.yourBio.edit
                    },
                    attrs: { href: _vm.data.yourBio.link }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.data.yourBio.edit ? "EDIT" : "ADD") +
                        "\n                        "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("CV Details")]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _c("span", { staticClass: "item-title" }, [
                  _vm.data.cvDetails.languages.completed
                    ? _c("span", { staticClass: "checkmark" }, [
                        _c("i", { staticClass: "fa fa-check" })
                      ])
                    : _c("span", { staticClass: "plusmark" }, [
                        _c("i", { staticClass: "fa fa-plus" })
                      ]),
                  _vm._v(
                    "\n                            Languages\n                        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "action-button",
                    class: {
                      edit: _vm.data.cvDetails.languages.edit,
                      add: !_vm.data.cvDetails.languages.edit
                    },
                    attrs: { href: _vm.data.cvDetails.languages.link }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.data.cvDetails.languages.edit ? "EDIT" : "ADD"
                        ) +
                        "\n                        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", { staticClass: "item-title" }, [
                  _vm.data.cvDetails.education.completed
                    ? _c("span", { staticClass: "checkmark" }, [
                        _c("i", { staticClass: "fa fa-check" })
                      ])
                    : _c("span", { staticClass: "plusmark" }, [
                        _c("i", { staticClass: "fa fa-plus" })
                      ]),
                  _vm._v(
                    "\n                            Education\n                        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "action-button",
                    class: {
                      edit: _vm.data.cvDetails.education.edit,
                      add: !_vm.data.cvDetails.education.edit
                    },
                    attrs: { href: _vm.data.cvDetails.education.link }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.data.cvDetails.education.edit ? "EDIT" : "ADD"
                        ) +
                        "\n                        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", { staticClass: "item-title" }, [
                  _vm.data.cvDetails.workExperience.completed
                    ? _c("span", { staticClass: "checkmark" }, [
                        _c("i", { staticClass: "fa fa-check" })
                      ])
                    : _c("span", { staticClass: "plusmark" }, [
                        _c("i", { staticClass: "fa fa-plus" })
                      ]),
                  _vm._v(
                    "\n                            Work Experience\n                        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "action-button",
                    class: {
                      edit: _vm.data.cvDetails.workExperience.edit,
                      add: !_vm.data.cvDetails.workExperience.edit
                    },
                    attrs: { href: _vm.data.cvDetails.workExperience.link }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.data.cvDetails.workExperience.edit
                            ? "EDIT"
                            : "ADD"
                        ) +
                        "\n                        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", { staticClass: "item-title" }, [
                  _vm.data.cvDetails.reference.completed
                    ? _c("span", { staticClass: "checkmark" }, [
                        _c("i", { staticClass: "fa fa-check" })
                      ])
                    : _c("span", { staticClass: "plusmark" }, [
                        _c("i", { staticClass: "fa fa-plus" })
                      ]),
                  _vm._v(
                    "\n                            Reference\n                        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "action-button",
                    class: {
                      edit: _vm.data.cvDetails.reference.edit,
                      add: !_vm.data.cvDetails.reference.edit
                    },
                    attrs: { href: _vm.data.cvDetails.reference.link }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.data.cvDetails.reference.edit ? "EDIT" : "ADD"
                        ) +
                        "\n                        "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("AIMS Modules")]),
            _vm._v(" "),
            _vm.data.aimModules.message
              ? _c("small", [_vm._v(_vm._s(_vm.data.aimModules.message))])
              : _vm._e(),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _c("span", { staticClass: "item-title" }, [
                  _vm.data.aimModules.cognitive.completed
                    ? _c("span", { staticClass: "checkmark" }, [
                        _c("i", { staticClass: "fa fa-check" })
                      ])
                    : _c("span", { staticClass: "plusmark" }, [
                        _c("i", { staticClass: "fa fa-plus" })
                      ]),
                  _vm._v(
                    "\n                            Congnitive Indicator\n                        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "action-button",
                    class: {
                      edit: _vm.data.aimModules.cognitive.edit,
                      add: !_vm.data.aimModules.cognitive.edit,
                      disabled: _vm.data.aimModules.cognitive.disabled
                    },
                    attrs: {
                      href: _vm.data.aimModules.cognitive.disabled
                        ? "#"
                        : _vm.data.aimModules.cognitive.link
                    }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.data.aimModules.cognitive.edit ? "EDIT" : "ADD"
                        ) +
                        "\n                        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", { staticClass: "item-title" }, [
                  _vm.data.aimModules.questionnaire.completed
                    ? _c("span", { staticClass: "checkmark" }, [
                        _c("i", { staticClass: "fa fa-check" })
                      ])
                    : _c("span", { staticClass: "plusmark" }, [
                        _c("i", { staticClass: "fa fa-plus" })
                      ]),
                  _vm._v(
                    "\n                            Questionnaire\n                        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "action-button",
                    class: {
                      edit: _vm.data.aimModules.questionnaire.edit,
                      add: !_vm.data.aimModules.questionnaire.edit,
                      disabled: _vm.data.aimModules.questionnaire.disabled
                    },
                    attrs: {
                      href: _vm.data.aimModules.questionnaire.disabled
                        ? "#"
                        : _vm.data.aimModules.questionnaire.link
                    }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.data.aimModules.questionnaire.edit
                            ? "EDIT"
                            : "ADD"
                        ) +
                        "\n                        "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _vm._t("default"),
            _vm._v(" "),
            _c("div", { staticClass: "edit-consent" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("toggle-button", {
                    attrs: {
                      labels: { checked: "YES", unchecked: "NO" },
                      color: {
                        checked: "#69BE28",
                        unchecked: "#586674",
                        disabled: "#CCCCCC"
                      },
                      "switch-color": {
                        checked: "#FFFFFF",
                        unchecked: "#FFFFFF"
                      },
                      value: _vm.editConsent,
                      sync: true
                    },
                    on: { change: _vm.onChangeEventHandler },
                    model: {
                      value: _vm.editConsent,
                      callback: function($$v) {
                        _vm.editConsent = $$v
                      },
                      expression: "editConsent"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "Do you agree to give your consent to allow recruiters to edit your profile?"
              )
            ])
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _vm._v(
        "\n                        Give Edit Consent\n                        "
      ),
      _c("span", [_c("i", { staticClass: "fa-regular fa-circle-question" })])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99bae28e", { render: render, staticRenderFns: staticRenderFns })
  }
}